/**
 * Journalisation console du site public. Seul module autorisé à appeler
 * `console.*` ; reprend le nom de Turbo.FrontEnd (`LogUtils.Log`) sans envoi serveur.
 */
export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

export abstract class LogUtils {
  static Log(message: string, level: LogLevel = 'info'): void {
    if (typeof console === 'undefined') {
      return;
    }

    switch (level) {
      case 'debug':
        console.debug(message);
        break;
      case 'warn':
        console.warn(message);
        break;
      case 'error':
        console.error(message);
        break;
      default:
        console.info(message);
        break;
    }
  }
}
